module.exports = __webpack_public_path__ + "img/brief_picture.2a3dbd53.png";